import { createContext } from "react";
import { useContext, useEffect, useState } from "react";
import { logoutIfTokenExpired } from "../utils/authSession";


const userContext = createContext();
const AuthContext = ({children}) => {
    const [loginUser, setLoginUser] = useState({});

    useEffect(() => {
        logoutIfTokenExpired();

        const sessionTimer = setInterval(() => {
            logoutIfTokenExpired();
        }, 30000);

        return () => clearInterval(sessionTimer);
    }, []);

    return (
        <userContext.Provider value={{loginUser,setLoginUser}}>
         {children}
        </userContext.Provider>
    )
};

export const useAuth = () => useContext(userContext);
export default AuthContext;
